import { useMutation } from '@tanstack/react-query';
import {
  DEMO_FILL_XML_FORM_MUTATION_KEY,
  type FillXmlFormDemoRequest,
  type FillXmlFormDemoResponse,
} from '../../contracts';
import { fillXmlFormDemo } from '../api/templates';

export function useMutateFillXmlFormDemo() {
  return useMutation<FillXmlFormDemoResponse, Error, FillXmlFormDemoRequest>({
    mutationKey: DEMO_FILL_XML_FORM_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillXmlFormDemo(request);
      return data;
    },
  });
}
